import { Component, h } from 'preact'
import classNames from 'classnames'
import Panel from '../panel'
import { BadgeList } from './index'

interface Props {
    badgeList: BadgeList,
    loading: boolean
}

interface State {
    viewAll: boolean
}
const maxBadgesDisplayed = 5

class BadgesOverviewPanel extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      viewAll: false
    }

    this.showAllBadges = this.showAllBadges.bind(this)
  }

  showAllBadges () {
    this.setState({ viewAll: true })
  }

  render (props: Props, state: State) {
    return <Panel
      collapsible
      title='Badges'
      customClass='userbox badge-overview-panel'
      titleClass='badge-overview__panel-header'
      bodyClass='badge-overview__panel-body'
    >
      { !props.loading && props.badgeList.length === 0 && <div>This user hasn't earned any badges yet</div> }
      { props.badgeList.length > 0 && props.badgeList.filter((badge, index) => (index < maxBadgesDisplayed || state.viewAll)).map(badge =>
        <div className={classNames('badge-block', 'qa-badge-block-' + badge.id)}>
          <img src={badge.image} /> <div class='badge-title'>{badge.title}</div>
        </div>
      )}
      {props.badgeList.length > maxBadgesDisplayed && !state.viewAll &&
        <a href='#' onClick={() => this.showAllBadges()}>
            View all {props.badgeList.length} badges
        </a>}
    </Panel>
  }
}

export default BadgesOverviewPanel
